import * as React from 'react';

import Button from 'components/ButtonDeprecated';
import Columns2 from 'components/Columns2';
import Field from 'components/Field';
import Image from 'components/Image';
import Link from 'components/Link';
import Radio from 'components/Radio';
import Row from 'components/Row';
import SyncTypePickerConstants, {
  SyncTypeTextProperties,
  textFromSyncType,
} from 'constants/SyncTypePickerConstants';
import Text from 'components/Text';
import TitleHeader from 'components/TitleHeader';
import { SyncType } from 'globalTypes';

import './styles/AdminSyncTypeClasslinkPickerView.scss';

type Props = {
  syncType: SyncType;
  displaySyncType: (syncType: SyncType) => void;
  handleContinue: (syncType: SyncType) => void;
};

class AdminSyncTypeClasslinkPickerView extends React.Component<Props> {
  renderSyncOption = (option: SyncType, textProperties: SyncTypeTextProperties) => {
    const { syncType, displaySyncType } = this.props;

    const subtext = (
      <Text weight="normal">
        {textProperties.subtextv2}
        {' '}
        <Link href={textProperties.textLink} target="_blank">
          Learn more
        </Link>
      </Text>
    );

    return (
      <Radio
        data-test={`sis-sync-type-option-${option}`}
        name={option}
        checked={syncType === option}
        onChange={() => displaySyncType(option)}
        key={option}>
        <TitleHeader
          className="AdminSyncTypeClasslinkPickerView-sync-type-title-header"
          title={textProperties.titlev2}
          subtext={subtext}
          size="small"
          textAlign="left"
        />
      </Radio>
    );
  };

  renderSyncTypeImage = (syncType: SyncType, textProperties: SyncTypeTextProperties) => {
    switch (syncType) {
      case SyncType.classlink:
      case SyncType.oneRosterSpreadsheet:
      case SyncType.remindSpreadsheetV2:
      case SyncType.clever:
      case SyncType.remindSpreadsheet:
        return <Image width="88%" src={textProperties.imagev2} />;
      default:
        console.log(`Unexpected sync type: ${syncType}`);
        return null;
    }
  };

  renderAlternativesFooter = () => {
    const { displaySyncType } = this.props;

    return (
      <Text align="left" color="graphite" size="small">
        It's also possible to{' '}
        <Link onClick={() => displaySyncType(SyncType.clever)}> sync with Clever</Link>, however the
        other types are recommended because they allow multiple points of contact information per
        person and allow for easier troubleshooting. You can also{' '}
        <Link onClick={() => displaySyncType(SyncType.remindSpreadsheet)}>
          sync with Remind CSV format 1.0.
        </Link>
      </Text>
    );
  };

  render() {
    const { handleContinue, syncType } = this.props;
    const syncOptions = [
      SyncType.classlink,
      SyncType.oneRosterSpreadsheet,
      SyncType.remindSpreadsheetV2,
    ];

    return (
      <React.Fragment>
        <Row size="small">
          <Text align="left" weight="semibold" size="medium">
            Choose a SIS sync type
          </Text>
        </Row>
        <Row size="small">
          <Columns2>
            <Field>
              {syncOptions.map(option => this.renderSyncOption(option, textFromSyncType[option]))}
            </Field>
            <Row size="small">{this.renderSyncTypeImage(syncType, textFromSyncType[syncType])}</Row>
          </Columns2>
        </Row>
        <Row size="small">
          <Text align="left" size="small" color="graphite" weight="normal">
            You'll have to contact Support to change your sync type later.
          </Text>
        </Row>
        <Row size="medium">
          <Text align="left">
            <Button
              data-test-selector="continue-select-sync-type-2"
              onClick={() => handleContinue(syncType)}
              level="primary">
              Continue
            </Button>
          </Text>
        </Row>
        <Row size="small">{this.renderAlternativesFooter()}</Row>
      </React.Fragment>
    );
  }
}

export default AdminSyncTypeClasslinkPickerView;
